// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_20Ybq","logo":"index_logo_3__OQ","logoAnimate":"index_logoAnimate_3RVgI","mainLogo":"index_mainLogo_3C8Nx","version":"index_version_3s_WF"};